/**
 * Format a datetime string from the server.
 * Server returns naive UTC strings (no timezone suffix).
 * We append 'Z' so the browser correctly interprets them as UTC
 * and converts to the device's local timezone.
 * Always uses 24-hour format.
 */
export const fmtDate = (d) => {
  if (!d) return '—';
  // If the string has no timezone info, treat it as UTC
  const s = typeof d === 'string' && !d.endsWith('Z') && !/[+\-]\d{2}:\d{2}$/.test(d)
    ? d + 'Z'
    : d;
  return new Date(s).toLocaleString(undefined, {
    hour12: false,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
};

export const fmtDateShort = (d) => {
  if (!d) return '—';
  const s = typeof d === 'string' && !d.endsWith('Z') && !/[+\-]\d{2}:\d{2}$/.test(d)
    ? d + 'Z'
    : d;
  return new Date(s).toLocaleDateString(undefined, {
    year: 'numeric', month: '2-digit', day: '2-digit',
  });
};
